export const MODAL_INTEGRATED_TRADE_IN_AEM = "integratedTradeInAem";
export type IntegratedTradeInModalType = {
    type: typeof MODAL_INTEGRATED_TRADE_IN_AEM;
};
